exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".service-row {\n  margin-top: 3rem;\n}", ""]);

// exports
